import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Row, Col, Table, Input } from "reactstrap";
import styles from './AddCategoryProductModal.module.scss';
import ProductSelectionModal from '../ProductSelectionModal/ProductSelectionModal';

const categoriesDetail = [
    { categoryName: "Electronics", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/Electronics01.png") },
    { categoryName: "Fashion", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/Fashion02.png") },
    { categoryName: "Home & Kitchen", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/HomeKitchen03.png") },
    { categoryName: "Beauty & Personal Care", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/BeautyCare04.png") },
    { categoryName: "Sports & Outdoors", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/Sports05.png") },
    { categoryName: "Books & Media", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/Books06.png") },
    { categoryName: "Toys & Games", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/ToysGames07.png") },
    { categoryName: "Home & Kitchen", categoryImg: require("../../../assets/images/SellerPortalImages/FBMPortalImages/CategoriesImages/HomeKitchen03.png") },
]

const AddCategoryProductModal = ({ isModalOpen, toggleModal }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const handleCheckboxChange = (categoryName) => {
        if (selectedCategories.includes(categoryName)) {
            setSelectedCategories(selectedCategories.filter((name) => name !== categoryName));
        } else {
            setSelectedCategories([...selectedCategories, categoryName]);
        }
    };

    const toggleSecondModal = () => {
        if (isSecondModalOpen) {
            setSelectedCategories([]);
        }
        setIsSecondModalOpen(!isSecondModalOpen);
    };

    const handleNextClick = () => {
        if (selectedCategories.length > 0) {
            toggleModal();
            toggleSecondModal();
        }
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div>
            <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg" centered>
                <ModalHeader toggle={toggleModal}>
                    <p className={styles.modalHeader}>Select Product Categories</p>
                </ModalHeader>
                <ModalBody>
                    <div className={styles.modalInstructions}>
                        You can select Multiple Categories or Specific Products from the categories
                        <Button
                            color="info"
                            className={styles.nextButton}
                            onClick={handleNextClick}
                            disabled={selectedCategories.length === 0}
                        >
                            Next
                        </Button>
                    </div>
                    <Row className={styles.categoriesRow}>
                        {categoriesDetail.map((category, index) => (
                            <Col md="6" key={index} className={styles.categoryCol}>
                                <div className={styles.categoryCard}>
                                    <Input
                                        type="checkbox"
                                        id={`category-${index}`}
                                        className={styles.categoryCheckbox}
                                        onChange={() => handleCheckboxChange(category.categoryName)}
                                    />
                                    <label
                                        htmlFor={`category-${index}`}
                                        className={styles.categoryLabel}
                                    >
                                        <img
                                            src={category.categoryImg}
                                            alt={category.categoryName}
                                            className={styles.categoryImage}
                                        />
                                        <span className={styles.categoryName}>{category.categoryName}</span>
                                    </label>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </ModalBody>
            </Modal>

            {/* Second Modal for selecting Products */}
            <ProductSelectionModal
                isSecondModalOpen={isSecondModalOpen}
                toggleSecondModal={toggleSecondModal}
                selectedCategories={selectedCategories}
                searchQuery={searchQuery}
                handleSearchChange={handleSearchChange}
            />

        </div>
    )
}

export default AddCategoryProductModal;